var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"shadow"},[_c('div',{staticClass:"btn",on:{"click":_vm.confirm}},[_vm._v("点击查看")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }